import { Loader2 } from 'lucide-react';
import { SheetPortal } from '../../shared/ui/SheetPortal';
import { useI18nStore } from '../../shared/i18n/i18nStore';
import { fmtMoney } from '../../shared/lib/format';
import type { WalletOrder } from './api';

export function DepositReturnDialog({ order, onNotReceived, onLater }: { order: WalletOrder; onNotReceived: () => void; onLater: () => void }) {
  const t = useI18nStore((s) => s.t);
  return (
    <SheetPortal>
      <div className="sheet-backdrop deposit-return-backdrop" role="presentation" onMouseDown={onLater}>
        <section className="deposit-return-dialog" role="dialog" aria-modal="true" aria-label={t('depositReturnTitle')} data-deposit-return-dialog-react="true" onMouseDown={(e) => e.stopPropagation()}>
          <Loader2 className="deposit-return-spinner" size={34} aria-hidden="true" />
          <h2>{t('depositReturnTitle')}</h2>
          <strong>{fmtMoney(Number(order.requestedAmount ?? order.receivedAmount ?? 0))}</strong>
          <small>{String(order.publicId || '')}</small>
          <p>{t('depositReturnBody')}</p>
          <button type="button" className="primary-button deposit-return-not-received" onClick={onNotReceived}>{t('depositReturnNotReceived')}</button>
          <button type="button" className="deposit-return-later" onClick={onLater}>{t('depositReturnLater')}</button>
        </section>
      </div>
    </SheetPortal>
  );
}
